<template>
<!-- 通道管理 -->
<div>
  <div class="search-box min">
    <div class="input-item">
      <span class="label">通道简称</span>
      <Input type="text" v-model="searchParams.name" placeholder="请输入" clearable />
    </div>
    <div class="input-item">
      <span class="label">通道code</span>
      <Input type="text" v-model="searchParams.code" placeholder="请输入" clearable />
    </div>
    <div class="btn-item">
      <Button type="primary" @click="searchAjax()">查询</Button>
    </div>
  </div>
  <div class="tools-box left">
    <div class="add-btn">
      <!-- <Button class="addbtn" type="primary" ghost @click="$refs.channelForm.open()">新增</Button> -->
      <Button class="addbtn" type="primary" ghost v-if="$units.pointAction('pro_4_3')" @click="$refs.importChannelCompany.open()">+ 导入合作通道</Button>
    </div>
  </div>
  <div class="table-box">
    <loading :isShow="listLoading" />
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{row}" slot="action">
        <span class="table-btn" @click="showDetail(row)">详情</span>
        <span class="table-btn" @click="toPageAbovepersonnel(row)">上号人员</span>
        <span class="table-btn" @click="remove(row)">删除</span>
      </template>
    </Table>
    <Page
      :total="total"
      :current="pageNum"
      :page-size="pageSize"
      show-total
      @on-change="getList"
      style="text-align: center"
    />
  </div>

  <Modal v-model="detailModal" title="详情" :footer-hide="true" class="my-modal top" class-name="insuranceModal" width="750px">
    <div class="row">
      <div class="cell">
        <div class="label">通道code</div>
        <div class="value">{{ channelDetail.code }}</div>
      </div>
      <div class="cell">
        <div class="label">通道全称</div>
        <div class="value">{{ channelDetail.fullName }}</div>
      </div>
    </div>
    <div class="row">
      <div class="cell">
        <div class="label">通道简称</div>
        <div class="value">{{ channelDetail.name }}</div>
      </div>
      <div class="cell">
        <div class="label">通道性质</div>
        <div class="value" v-if="channelDetail.channelType==1">总公司</div>
        <div class="value" v-if="channelDetail.channelType==2">分公司</div>
      </div>
    </div>
    <div class="row">
      <div class="cell">
        <div class="label">所在区域(省市)</div>
        <div class="value">{{ channelDetail.province }}{{ channelDetail.city }}</div>
      </div>
      <div class="cell" v-if="channelDetail.channelType==2">
        <div class="label">所属总公司</div>
        <div class="value">{{ channelDetail.parentName }}</div>
      </div>
    </div>
  </Modal>
  <!-- 通道新增 -->
  <channel-form ref="channelForm" @success="searchAjax()"></channel-form>
  <!-- 导入 -->
  <!-- <import-tool ref="importTool" @success="searchAjax()"></import-tool> -->
  <import-channel-company ref="importChannelCompany" :getCompanyList="searchAjax"></import-channel-company>

</div>
</template>
<script>
import importTool from '@/components/commons/importTool/index2';
import importChannelCompany from './importChannelCompany';
import channelForm from "./channelForm";
import {pageTool} from "@/api/mixins";
import {config} from "./channelPage.config.js";
export default {
  mixins:[pageTool, config],
  components:{channelForm,importTool, importChannelCompany},
  data: () => ({
    tabId:"",
    formList: {
      code:'', // 保司code
      name: '', // 公司名称
    },
    channelDetail:{},
    detailModal:false,
    loading: false,
  }),
  created() {
    
  },
  methods: {
    init(){
      this.pageNo=1
      this.initListAjax("/buz/insuranceChannel/read/page");
    },
    // 详情
    showDetail(row) {
      this.channelDetail = row;
      this.detailModal = true;
    },
    // 上号人员
    toPageAbovepersonnel(row) {
      this.$router.push({
        path:"/offline/insuranceManage/abovePersonnel",
        query:{
          supplierType:2,
          supplierId:row.id,
        }
      })
    },
    // 删除
    remove(item) {
      this.$notice.inquiry("请确认是否删除此通道？").then(async () => {
        this.$http({
          url: '/buz/insuranceChannel/del',
          type: 'get',
          data: {
            id: item.id,
          },
        }).then((res) => {
          this.$notice.success("操作成功");
          this.searchAjax();
        })
      });
    },
    // 导入员工
    importData(){
      const dic = JSON.parse(localStorage.dic)['CHANNEL_EXPORT']
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params:{},
        uploadParams:{},
        template:key,
        templateName:dic[key],
        uploadUrl:"/buz/insuranceChannel/batch/upload",
        errorUrl:"/buz/insuranceChannel/exportError",
      })
    },
  },
}
</script>
<style lang='scss' scoped>
@import './channelPage';
</style>